import React from 'react'
import styled from 'styled-components'
import { readableColor } from 'polished'
import { baseTiltifyUrl } from '../../../utils'
import { useIntl } from 'react-intl'
import { authenticationMessages } from '../../../translations'

const StyledWrapper = styled.div`
  font-size: 0.8rem;
  margin: 1rem 0 0;
  color: ${({ theme }) => readableColor(theme.backgroundColor || '#000')};
`

const StyledLink = styled.a`
  font-weight: 700;
  text-decoration: none;
  color: ${({ theme }) => readableColor(theme.backgroundColor || '#000')};
`

export function TermsOfService() {
  const { formatMessage } = useIntl()

  return (
    <StyledWrapper>
      {formatMessage(authenticationMessages.TOS, {
        tos: (str) => (
          <StyledLink href={`${baseTiltifyUrl()}/pages/terms-of-service`} target='_blank'>
            {str}
          </StyledLink>
        ),
        privacy: (str) => (
          <StyledLink href={`${baseTiltifyUrl()}/pages/privacy-policy`} target='_blank'>
            {str}
          </StyledLink>
        ),
      })}
    </StyledWrapper>
  )
}
